import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import BaseComponent from 'foundation/base-component';
import store from 'general/js/store';
import LiveTextLayout from './live-text-layout';

class LiveText extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <LiveTextLayout options={this.options} />
            </Provider>,
            this.element
        );
    }
}

export default LiveText;
